import styled from 'styled-components';
import { screens } from '../../assets/styles/screens';
import colors from '../../assets/styles/colors';

export const FilterContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid ${colors.grayLight};
  border-bottom: 1px solid ${colors.grayLight};
  display: flex;
  padding: 10px 0px;
`;

export const FilterColumn = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-right: 1px solid ${colors.grayLight};
  padding-left: 15px;
  padding-right: 15px;

  @media ${screens.desktopL} {
    &:nth-child(1) {
      max-width: 450px;
    }

    &:nth-child(2) {
      max-width: 350px;
      justify-content: center;
    }

    &:nth-child(3) {
      max-width: 100%;
      justify-content: flex-start;
    }
  }

  @media ${screens.desktopSm} {
    &:nth-child(1) {
      max-width: 320px;
    }

    &:nth-child(2) {
      max-width: 230px;
      justify-content: center;
    }
  }

  &:last-child {
    border-right: none;
    justify-content: space-between;
  }
`;

export const FilterInputSearch = styled.input`
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  margin-left: 26px;
  font-size: 12px;

  ::placeholder,
  ::-webkit-input-placeholder {
    font-size: 12px;
    color: ${colors.textSecondary};
    opacity: 0.9;
    letter-spacing: 0.03em;
    font-family: 'Montserrat', sans-serif;;
  }

  :-ms-input-placeholder {
    font-size: 12px;
    color: ${colors.textSecondary};
    opacity: 0.9;
    letter-spacing: 0.03em;
    font-family: 'Montserrat', sans-serif;;
  }
`;

export const FilterOrderBy = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterOrderBySpan = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  color: ${colors.textSecondary};
`;

export const FilterOrderByOption = styled.div`
  color: ${colors.textPrimary};
  font-size: 12px;
  margin-left: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    transform: ${prop => prop.current ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }
`;

export const FilterShowContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 270px;
  margin-right: 15px;
`;

export const FilterShowOptionSpan = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  color: ${colors.textSecondary};
  margin-right: 15px;
`;

export const FilterShowOptionSelect = styled.div`
  width: 100%;
  max-width: 210px;
  position: relative;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const FilterShowOptionContent = styled.div`
  width: 100%;
  max-width: 210px;
  left: 0;
  position: absolute;
  display: block;
  top: 30px;
  display: flex;
  flex-direction: column; 
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 10px;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
  transition: ease-in-out .2s;
`;

export const FilterShowOptionSelectOption = styled.div`
  padding: 10px;
  background: ${prop => prop.active ? colors.bgFilterSelected : colors.white};
  transition: ease-in-out .2s;

  &:hover {
    background: ${colors.bgSuccess};
  }

  &:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const FilterShowOptionSelected = styled.span`
  font-size: 12px;
  color: ${colors.textPrimary};
`;

export const FilterDisplay = styled.div`
  display: flex;
  background: ${colors.white};
`;

export const FilterDisplayIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${prop => prop.row ? colors.bgSecondary : colors.white};
  box-shadow: ${prop => prop.row ? `0px 5px 10px ${colors.bgFilterSelected}` : 'none'};
  -webkit-box-shadow: ${prop => prop.row ? `0px 5px 10px ${colors.bgFilterSelected}` : 'none'};
  -moz-box-shadow: ${prop => prop.row ? `0px 5px 10px ${colors.bgFilterSelected}` : 'none'};
  border-radius: ${prop => prop.row ? '8px' : '0px'} !important;
  border-collapse: collapse;
  cursor: pointer;

  svg {
    color: ${prop => prop.row ? colors.white : colors.bgSecondary};;
  }
`;
